import { render, staticRenderFns } from "./ContactUsView.vue?vue&type=template&id=7b96fbc0"
import script from "./ContactUsView.vue?vue&type=script&lang=js"
export * from "./ContactUsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports